import type { NotificationApiItem } from '../types';

export function getNotificationTrackingProperties(
  item: NotificationApiItem,
  href?: string
): Record<string, string> {
  const { content } = item;
  const data = content.data;
  const values = {
    company_id: data?.companyId,
    job_id: data?.opportunityId ?? data?.jobId,
    application_id: data?.applicationId,
    campaign_id: data?.campaignId,
    post_id: data?.postId,
    topic_id: data?.topicId,
    template_key: content.templateKey,
    action_link: href,
    noti_type:
      item.key_group ??
      content.key_group ??
      content.keyGroup ??
      content.groupTemplateKey,
  };
  const properties: Record<string, string> = {};

  for (const [key, value] of Object.entries(values)) {
    if (value === undefined || value === null) continue;

    const normalized = String(value).trim();

    if (normalized) properties[key] = normalized;
  }

  return properties;
}
